/* global $ window Modernizr */

const $content = $('.content > div')
const $window  = $(window)

const checkContentSize = () => {
    if (Modernizr.mq('(max-width: 950px)') || $content.height() + 180 > $window.height()) {
        $('body').addClass('mobile')

        $window.off('resize.content-size')
    }
}

let t = 0

$window.on('resize.content-size', () => {
    window.clearTimeout(t)

    t = window.setTimeout(checkContentSize, 100)
})

checkContentSize()

module.exports = {
    checkContentSize
}



/** WEBPACK FOOTER **
 ** ./js/credentials/responsive.js
 **/